import React from "react";
import { Helmet } from "react-helmet-async";

const About = () => {
  return (
    <div className="p-[6%] sm:px-[10%] sm:py-[2%]">
      <Helmet>
        <title>{`About Us - Clariss Bangladesh`}</title>
        <meta
          name="description"
          content="Discover Clariss — a globally inspired beauty brand that unites nature, science, and craftsmanship. Experience skincare, body care, and fragrances created with integrity, sustainability, and care."
        />
        <link rel="canonical" href="https://clarissbangladesh.com/about" />
      </Helmet>

      {/* Header */}
      <p className="font-bold my-10 text-center">
        <span className="text-accent font-bold text-4xl mr-2">Clariss</span>
        <span className="text-accent font-bold text-black text-4xl">
          Bangladesh
        </span>
      </p>

      <h1 className="text-3xl text-secondary font-bold my-10 text-center sm:w-[600px] mx-auto">
        Clariss — Where Nature Meets Beauty
      </h1>

      {/* Content Section */}
      <div className="flex flex-col lg:flex-row gap-10 items-center justify-center">
        <div className="w-[100%] lg:w-[50%] space-y-6">
          <p className="font-bold text-[18px] leading-relaxed">
            At Clariss, beauty is more than what you see — it’s how you feel.
            Registered in the United States, Clariss is a globally inspired
            beauty brand that brings together the best of nature, science, and
            craftsmanship from around the world.
          </p>

          <h2 className="text-accent font-bold text-2xl mt-10 mb-4">
            Our Essence & Vision
          </h2>

          <p className="font-bold text-[18px] leading-relaxed">
            <span className="text-accent font-semibold">
              Inspired by Nature, Perfected by Science
            </span>
            <br />
            Clariss blends natural ingredients, modern technology, and timeless
            care traditions to create skincare, body care, and fragrance
            products that deliver visible results — safely, gently, and
            effectively.
          </p>

          <p className="font-bold text-[18px] leading-relaxed">
            <span className="text-accent font-semibold">
              Crafted for Every Skin, Every Story
            </span>
            <br />
            Our formulations are created through collaborations with global
            laboratories and manufacturers who share our passion for quality and
            authenticity. Whether inspired by the purity of European botanicals
            or the richness of Asian beauty rituals, Clariss celebrates
            diversity through care that truly works.
          </p>

          <p className="font-bold text-[18px] leading-relaxed">
            <span className="text-accent font-semibold">
              Global Presence, Local Heart
            </span>
            <br />
            Though our corporate roots are in the USA, our reach is proudly
            international — with products developed and manufactured through
            trusted global partners, meeting strict quality and halal-friendly
            standards.
          </p>

          <hr className="my-8 border-gray-300" />

          <h2 className="text-accent font-bold text-2xl mb-4">
            What Makes Clariss Special
          </h2>

          <p className="font-bold text-[18px] leading-relaxed">
            <span className="text-accent font-semibold">
              Integrity in Every Drop
            </span>
            <br />
            We believe that beauty should never come at the cost of honesty.
            Every Clariss product is made with ethically sourced, safe, and
            transparent ingredients — free from harmful chemicals and harsh
            additives.
          </p>

          <p className="font-bold text-[18px] leading-relaxed">
            <span className="text-accent font-semibold">
              Sustainability with Style
            </span>
            <br />
            Our vision of beauty includes respect for the planet. We embrace
            eco-friendly packaging, sustainable sourcing, and responsible
            production practices that protect both people and the earth.
          </p>

          <p className="font-bold text-[18px] leading-relaxed">
            <span className="text-accent font-semibold">
              Holistic Care for Modern Living
            </span>
            <br />
            Clariss offers a full spectrum of self-care — from skincare and body
            care to fragrances and natural honey collections — designed to
            nourish, uplift, and inspire confidence from within.
          </p>

          <hr className="my-8 border-gray-300" />

          <h2 className="text-accent font-bold text-2xl mb-4">Our Promise</h2>

          <p className="font-bold text-[18px] leading-relaxed">
            <span className="text-accent font-semibold">
              To You, From Clariss:
            </span>
            <br />
            We promise purity without pretense, quality without compromise, and
            beauty that feels as good as it looks.
          </p>

          <p className="font-bold text-[18px] leading-relaxed">
            Clariss is not just another brand — it’s a celebration of modern
            self-care, rooted in nature, guided by science, and carried by
            heart.
          </p>

          <p className="text-accent font-bold text-[20px] mt-6">
            Clariss — Because beauty begins with care.
          </p>

          <p className="mt-10 font-bold text-[16px] leading-relaxed">
            Under License <br />
            Clariss LLC
            <br />
            DWC-LLC, P.O. BOX-712688, Dubai, United Arab Emirates, 712688
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
